<template>
  <div id="search-bars">
    <div class="container">
      <form action id="searchForm" class="relative-section" @submit.prevent="onSubmit">
        <div class="list-inline" v-click-outside="clickOutSite">
          <div class="item-inline search-wtours">
            <div
              class="select-custom field-location"
              :class="{
                                active: isOpenDopdown === 'campings'
                            }"
            >
              <a href class="current" @click.prevent="setIsOpenDropdown('campings')">
                <span v-if="camping" v-html="camping.title.rendered"></span>
                <span v-else>
                  {{$t(
                  "searchBar.Tous les campings clubs"
                  )}}
                </span>
              </a>
              <slide-up-down :active="isOpenDopdown === 'campings'" tag="ul" :duration="100">
                <li v-for="(item, index) in campingClubs" :key="index">
                  <a
                    href="#"
                    v-html="item.title.rendered "
                    @click.prevent="
                                            onSelect('camping', item)
                                        "
                  ></a>
                </li>
              </slide-up-down>
            </div>
          </div>
          <div
            class="item-inline search-wchalets"
            :class="{
                            active: isOpenDopdown === 'chalets'
                        }"
          >
            <div class="select-custom">
              <a class="current" @click.prevent="setIsOpenDropdown('chalets')">
                {{
                type
                ? type.title.rendered
                : $t("searchBar.Please select")
                }}
              </a>
              <slide-up-down
                :active="isOpenDopdown === 'chalets'"
                tag="ul"
                :duration="100"
                v-if="typesOptions.length > 0"
              >
                <li v-for="(item, index) in typesOptions" :key="index">
                  <a @click.prevent="onSelect('type', item)">{{ item.title.rendered }}</a>
                </li>
              </slide-up-down>
            </div>
          </div>
          <div class="item-inline search-wdates search-wdates1">
            <date-picker
              v-model="dateFrom"
              format="DD/MM/YYYY"
              type="date"
              :placeholder="$t('searchBar.Arrivée')"
              :disabled-date="disabledDateFrom"
              @open="onOpenDatePicker('dateFrom')"
            ></date-picker>
          </div>
          <div class="item-inline search-wdates">
            <date-picker
              v-model="dateTo"
              format="DD/MM/YYYY"
              type="date"
              :placeholder="$t('searchBar.Départ')"
              :disabled-date="notBeforeDate"
              @open="onOpenDatePicker('dateTo')"
            ></date-picker>
          </div>
          <div class="item-inline search-wpeople">
            <div
              class="select-custom field-people"
              :class="{
                                active: isOpenDopdown === 'adultes'
                            }"
            >
              <a href class="current" @click.prevent="setIsOpenDropdown('adultes')">
                {{
                adult + child + child1 > 0
                ? adult + child + child1
                : ""
                }}
                {{ $t("searchBar.adultes") }}
              </a>
              <slide-up-down :active="isOpenDopdown === 'adultes'" tag="ul" :duration="100">
                <li class="quantity-item" v-for="(item, index) in adultsConfig" :key="index">
                  <b>{{ $t(`app.${item.name}`) }}</b>
                  <div class="quantity-group quantity-adulte">
                    <a
                      href
                      class="minus"
                      @click.prevent="
                                                item.quantity > 0
                                                    ? item.quantity--
                                                    : 0
                                            "
                      v-bind:class="{
                                                isDisabled: item.quantity <= 0
                                            }"
                    >-</a>
                    <input type="number" min="0" disabled v-model="item.quantity" />
                    <a href class="plus" @click.prevent="item.quantity++">+</a>
                  </div>
                </li>
                <li>
                  <a @click.prevent="onApplyAdults()" class="btn apply">{{ $t("app.Ajouter") }}</a>
                </li>
              </slide-up-down>
            </div>
          </div>
          <button class="btn font-bold font-balo" type="submit">{{ $t("searchBar.Rechercher") }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import ClickOutside from "vue-click-outside";
import { mapState, mapActions, mapMutations } from "vuex";
import { get, forEach, filter, includes } from "lodash";
import { adults } from "@/helper/config";
import { formatBookDate } from "@/helper/calculateDays";
const today = new Date();
export default {
  name: "SearchBar",
  components: { DatePicker },
  data() {
    const adultsConfig = adults.filter((item) => item.key !== "animal");
    return {
      camping: null,
      dateFrom: null,
      dateTo: null,
      isOpenDopdown: null,
      type: null,
      adult: null,
      child: null,
      child1: null,
      animal: null,
      adultsConfig: adultsConfig,
      typesOptions: [],
    };
  },
  mounted() {
    this.adultsConfig = adults
      .filter((item) => item.key !== "animal")
      .map((item) => ({ ...item, quantity: 0 }));
  },
  computed: {
    ...mapState({
      campingClubs: (state) => get(state, "campingClubs.list", []),
      categories: (state) => get(state, "categories.list", []),
      types: (state) => get(state, "types.list", []),
    }),
  },
  methods: {
    ...mapActions("hotels", ["getReferences", "getAvailability"]),
    ...mapMutations("hotels", ["setFilter"]),
    disabledDateFrom(date) {
      if (!this.dateTo) {
        return date <= today;
      }
      return date <= today || date >= this.dateTo;
    },
    notBeforeDate(date) {
      return date <= this.dateFrom;
    },
    setIsOpenDropdown(key) {
      this.isOpenDopdown = this.isOpenDopdown !== key ? key : null;
    },
    clickOutSite() {
      this.isOpenDopdown = null;
    },
    onOpenDatePicker(type) {
      this.isOpenDopdown = null;
      if (type === "dateFrom") {
        this.dateTo = null;
      }
    },
    onSelect(key, value) {
      this[key] = value;
      this.isOpenDopdown = null;
      if (key === "camping") {
        this.getTypesByCamping(value);
        this.type = null;
      }
      if (key === "type") {
        if (value.title.rendered === "Emplacement nu") {
          this.adultsConfig = adults.map((item) => ({
            ...item,
            quantity: 0,
          }));
        } else {
          const adultsConfig = adults.filter((item) => item.key !== "animal");
          this.adultsConfig = adultsConfig.map((item) => ({
            ...item,
            quantity: 0,
          }));
        }
        forEach(this.adultsConfig, (item) => {
          this[item.key] = item.quantity;
        });
      }
    },
    onApplyAdults() {
      forEach(this.adultsConfig, (item) => {
        this[item.key] = item.quantity;
      });
      if (this.adult + this.child + this.child1 > 6) {
        this.$bvToast.toast(
          this.$i18n.t(
            "app.Les hébergements ne peuvent pas accueillir plus de 6 personnes"
          ),
          {
            title: this.$i18n.t("app.Error"),
            variant: "danger",
            solid: true,
          }
        );
        return;
      }
      this.isOpenDopdown = null;
    },
    onSubmit() {
      if (
        !this.camping ||
        !this.dateFrom ||
        !this.dateTo ||
        !this.type ||
        !this.adult
      ) {
        this.$bvToast.toast(
          this.$i18n.t(
            "app.Please select camping, type, date from, date to, adults"
          ),
          {
            title: this.$i18n.t("app.Error"),
            variant: "danger",
            solid: true,
          }
        );
        return;
      }
      if (this.adult + this.child + this.child1 > 6) {
        this.$bvToast.toast(
          this.$i18n.t(
            "app.Les hébergements ne peuvent pas accueillir plus de 6 personnes"
          ),
          {
            title: this.$i18n.t("app.Error"),
            variant: "danger",
            solid: true,
          }
        );
        return;
      }
      let dataReferences = {
        camping: this.camping ? this.camping.id : null,
        dateFrom: formatBookDate(this.dateFrom),
        dateTo: formatBookDate(this.dateTo),
        type: get(this, "type.id"),
        adult: this.adult || 0,
        child: this.child || 0,
        child1: this.child1 || 0,
      };
      if (this.animal > 0) {
        dataReferences.animal = this.animal;
      }
      this.setFilter(dataReferences);
      this.$router.push("/result");
    },
    getTypesByCamping(camping) {
      const types = filter(this.types, (item) => {
        if (Array.isArray(get(item, "acf.types_camping"))) {
          return includes(get(item, "acf.types_camping", []), camping.id);
        }
        return get(item, "acf.types_camping") === camping.id;
      });
      // console.log("camping", camping);
      // console.log("types", types);
      // console.log("types", this.types);
      this.typesOptions = types;
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
